import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type { FlashType } from 'modules/core/store/models/app'
import app from 'modules/core/store/models/app'

import { useApiKeys } from 'modules/api_public/store/collections/apiKeys'

import type { Action, State } from '../../Table/types'

interface Props {
  dispatch: React.Dispatch<Action>
  state: State
}

const EditModal = ({ dispatch, state }: Props) => {
  const [inputName, setInputName] = React.useState<string>('')
  const apiKeys = useApiKeys()

  const showFlashMessage = (type: FlashType, message: string) => {
    app.setFlash({
      type,
      message,
    })
  }

  const updateKey = async () => {
    try {
      if (inputName !== '') {
        const { success } = await asyncAction(async () => {
          apiKeys.find({ id: state.key })?.update({ name: inputName })
        })

        if (success) {
          showFlashMessage('correct', i18n.t('settings.api_keys.edit.updated'))
        }

        dispatch({ type: 'closeModals' })
      } else {
        throw Error
      }
    } catch (error) {
      showFlashMessage('wrong', i18n.t('settings.api_keys.edit.error'))
      dispatch({ type: 'closeModals' })
    }
  }

  return (
    <Modal
      title={i18n.t('settings.api_keys.edit.title')}
      description={i18n.t('settings.api_keys.edit.description')}
      illustration="network-group"
      onClose={() => dispatch({ type: 'closeModals' })}
      onSubmit={() => {
        updateKey()
      }}
      footer={
        <>
          <Button type="secondary" onClick={() => dispatch({ type: 'closeModals' })}>
            {i18n.t('settings.api_keys.edit.cancel')}
          </Button>
          <Button type="primary" submit>
            {i18n.t('settings.api_keys.edit.save')}
          </Button>
        </>
      }
    >
      <TextField label="Key name" placeholder="Key name" onChange={setInputName} />
    </Modal>
  )
}

export default EditModal
